import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-validation/build/form";
//import Button from "react-validation/build/button";
import {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  clearUpdate,
  getFormVerifyDetailsByStudentId,
  admissionInsertVerifyDetails,
  getAllAdmissionFormConfigurationByFormId,
  getAdmissionTotalFormFeesByStudentId,
  payOnlinePayment,
  getStudentStatusDetailsByUserId,
  getAcademicQuotaDetailsByStudentId,
  getOtherDetailsByStudentId,
} from "../../actions";
import moment from "moment";
import { NavLink } from "react-router-dom";
import AcademicInfoPrint from "./AcademicInfoPrint";
import Modal from "react-responsive-modal";
import notification from "../../utils/notification";
const keys = require("../../config/keys");

class AdmissionVerifyPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allLanguagesData: [],
      allAchievementsData: [],
      modelOpen: false,
      btnDisabled: true,
      selectedQuota: [],
      isNextBtn:false,
      isVerifyClk:false
    };
  }
  async componentWillMount() {
    this.props.getUserDetailsByUserId(this.props.auth.userId);
    this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);

    const PromiseArry = [
      this.props.getAchievementsByStudentId(this.props.auth.userId),
      this.props.getLanguageknownsByStudentId(this.props.auth.userId),
      this.props.getFormVerifyDetailsByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),
      this.props.getAdmissionTotalFormFeesByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),

      // this.props.getStudentStatusDetailsByUserId(this.props.auth.userId)
      this.props.getStudentStatusDetailsByUserId(
        this.props.auth.userId,
        this.props.auth.admissionConfig.AyId
      ),
      this.props.getAcademicQuotaDetailsByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),
      this.props.getOtherDetailsByStudentId(
        this.props.FormId,
        this.props.auth.userId
      ),
    ];
    await Promise.all(PromiseArry);

    if (this.props.admissionTotalFormFees.length > 0) {
      await this.setState({
        FormFees: this.props.admissionTotalFormFees[0].FormFees
      });
    }
    if (this.props.admissionVerifyDetails.length > 0) {
      await this.setState({
        IsVerifyId: this.props.admissionVerifyDetails[0].Id,
        IsFormFeesPaid: this.props.admissionVerifyDetails[0].IsFormFeesPaid,
        IsVerifyUser: this.props.admissionVerifyDetails[0].IsVerify,
        AdmissionNo: this.props.admissionVerifyDetails[0].AdmissionNo,
        AdmissionDate:
          this.props.admissionVerifyDetails[0].AdmissionDate !== "" &&
          moment(this.props.admissionVerifyDetails[0].AdmissionDate).format(
            "DD-MM-YYYY"
          )
      });
    }
    await this.setState({
      allAchievementsData: this.props.achievementByStudent,
      allLanguagesData: this.props.languageKnownByStudent
    });
    if (this.props.admissionStudentStatusDetails.length > 0) {
      var admStatusDetails = this.props.admissionStudentStatusDetails.filter(
        i => {
          return i.AdmFormGroupId === parseInt(this.props.FormId, 10);
        }
      );
      await this.setState({
        AfdId: admStatusDetails[0].afdId
      });
    }

    var selectedQuota = this.props.academicQuotaList.map((item) => {
      item.value = parseInt(item.AdmQuotaId, 10);
      item.label = item.AdmQuota;
      return item;
    });
    await this.setState({
      selectedQuota: selectedQuota,
    });
  }
  onOpenModal = () => {
    this.setState({ modelOpen: true });
  };
  onCloseModal = () => {
    this.setState({ modelOpen: false,isNextBtn:!this.state.isVerifyClk });
  };
  handleCheckVerify = e => {
    this.setState({
      IsVerify: e.target.checked !== true ? 0 : 1,
      btnDisabled: false,
      isVerifyClk:true
      
    });
    if (!e.target.checked) {
      this.setState({ btnDisabled: true ,isVerifyClk:false});
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    var CourseIDS = this.props.admissionProgram
      .filter(i => i.Id > 0)
      .map(data => data.CourseID)
      .join(",");
    var verifyData = {
      Id: this.state.IsVerifyId,
      IsVerify: this.state.IsVerify,
      IsVerifyBy: this.props.auth.userId,
      AdmissionNo: this.state.AdmissionNo,
      FormId: this.props.FormId,
      StudentId: this.props.auth.userId,
      CourseIDS: CourseIDS || "",
      AfdId: this.state.AfdId,
      mmp_txn: "",
      FormFees: this.state.FormFees
    };
    let verified = await this.props.admissionInsertVerifyDetails(verifyData);
    if (verified) {
      window.location.replace(`/Account/StudentAccount/AdmissionForm/4/${this.props.FormId}`)
      this.onCloseModal();
      this.setState({
        IsVerifyUser: this.state.IsVerify
      });
      notification("success", "Success", "Verify Successfully");
    }
  };
  render() {
    return (
      <div
        className={this.state.IsVerifyUser ? "main-bg" : "main-bg  doNotPrint"}
      >
        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          classNames={{
            modal: "modelOf90Percentage"
          }}
        >
          <Form onSubmit={this.handleSubmit.bind(this)}>
            {this.props.admissionFormList.length > 0 && (
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Verify</h5>
                </div>
                <div className="modal-text">
                  <h5 className="inner-title mb-3">
                    Declaration by the Applicant
                  </h5>
                  {this.props.admissionFormList
                    .filter(data => {
                      return data.ID === parseInt(this.props.FormId, 10);
                    })
                    .map((item, index) => {
                      return (
                        <div
                          dangerouslySetInnerHTML={{ __html: item.Declaration }}
                          key={index}
                        />
                      );
                    })}
                  <div className="form-group mb-0 mt-3">
                    <input
                      type="checkbox"
                      id="IsVerify"
                      name="IsVerify"
                      checked={this.state.IsVerify ? true : false}
                      onChange={this.handleCheckVerify}
                    />
                    <label className="checkbox-inline" htmlFor="IsVerify">
                      Yes I Agree
                    </label>

                    <br/>
                     <span className="Notes" style={{color:'red',fontSize:'0.8rem',position:'relative',top:'14px'}}> Note: Once you verify you will be redirected to next page </span>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-success btn-lg theme-btn"
                    onClick={this.onCloseModal}
                    disabled={this.state.btnDisabled}
                  >
                    <i className="fa fa-check-circle" aria-hidden="true" />
                    Yes I Agree
                  </button>
                </div>
              </div>
            )}
          </Form>
        </Modal>

        <h2 className="page-title sub-title">Verify and Print Form</h2>

        <div className="pageBreakheader">
          <header className="print-header">
            <div className="printAdmissionLogo">
              <img src={keys.websiteSetting.PrintLogo} alt="Logo" />
            </div>
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter(data => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>
                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li className="text-capitalize">
                            <strong>Applicant Name</strong> :{" "}
                            {this.props.userDetails.FullUserName || ""}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                          <br />
                          <strong>Form Fees</strong> :{" "}
                          {this.state.FormFees ? `₹${this.state.FormFees}` : ""}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header>
          <div className="mb-3 print-table">
            {this.props.admissionFormConfiguration.filter(
              (item) =>
                item.DisplayStatus === 1 && item.AdmFormGroupSectionId === 6
            ).length > 0 &&
              this.props.admissionOtherDetails.length > 0 &&
              this.state.selectedQuota.length > 0 && (
                <div className="mb-2">
                  <h5 className="inner-title  mb-3">Applying Through</h5>
                  <table className="mb-1 table table-bordered mb-0">
                    <tbody>
                      <tr>
                        {this.state.selectedQuota.map((i, index) => {
                          return (
                            <td className="align-middle" key={index}>
                              {`${index + 1}. ${i.AdmQuota}`}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 7
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1">
                <thead>
                  <tr className="table-light">
                    <th colSpan="4">Personal Detail</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>First Name</span> :&nbsp;
                      {this.props.userDetails.FirstName}
                    </td>
                    <td width="30%">
                      <span>Middle Name</span> :&nbsp;
                      {this.props.userDetails.MiddleName}
                    </td>
                    <td width="24%">
                      <span>Last Name</span> :&nbsp;
                      {this.props.userDetails.LastName}
                    </td>
                    <td
                      rowSpan="4"
                      className="align-top dashuser_photo userPick"
                      width="150px"
                    >
                      {this.props.userDetails.ProPic !== null &&
                      this.props.userDetails.ProPic !== undefined ? (
                        <img
                          src={
                            keys.ServicePath + this.props.userDetails.ProPic ||
                            ""
                          }
                          className="mx-auto d-block img-thumbnail"
                          alt="profile"
                        />
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Gender</span> :&nbsp;
                      {this.props.userDetails.Gender}
                    </td>
                    <td>
                      <span>DOB</span> :&nbsp;
                      {moment(this.props.userDetails.DOB).isValid()
                        ? moment(this.props.userDetails.DOB).format(
                            "DD-MM-YYYY"
                          )
                        : ""}
                    </td>
                    <td>
                      <span>Blood Group</span> :&nbsp;
                      {this.props.userDetails.BloodGroup}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Marital Status</span> :&nbsp;
                      {this.props.userDetails.MaritalStatus}
                    </td>
                    <td>
                      <span>Nationality</span> :&nbsp;
                      {this.props.userDetails.Nationality}
                    </td>
                    <td>
                      <span>Religion</span> :&nbsp;
                      {this.props.userDetails.ReligionName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Caste Category</span> :&nbsp;
                      {this.props.userDetails.CasteCategory}
                    </td>
                    <td>
                      <span>Caste</span> :&nbsp;
                      {this.props.userDetails.Caste}
                    </td>
                    <td>
                      <span>Sub-Caste</span> :&nbsp;
                      {this.props.userDetails.SubCaste}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Email</span> :&nbsp;
                      {this.props.userDetails.Email}
                    </td>
                    <td>
                      <span>Mobile</span> :&nbsp;
                      {this.props.userDetails.StudMobNo}
                    </td>
                    <td colSpan="2">
                      <span>Emergency Mobile No.</span> :&nbsp;
                      {this.props.userDetails.EmergencyMobNo}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Aadhar No</span> :&nbsp;
                      {this.props.userDetails.AadharCard}
                    </td>
                    <td>
                      <span>Physically Challenged</span> :&nbsp;
                      {this.props.userDetails.PhysicallyChallenge === 1
                        ? "Yes"
                        : "No"}
                    </td>
                    {this.props.userDetails.PhysicallyChallenge === 1 && (
                      <td>
                        <span>Physically Challenged Info</span> :&nbsp;
                        {this.props.userDetails.PhysicallyChallengeInfo}
                      </td>
                    )}
                    <td>
                      <span>Occupation</span> :&nbsp;
                      {this.props.userDetails.Occupation}
                    </td>
                    {this.props.userDetails.PhysicallyChallenge !== 1 && <td />}
                  </tr>
                  <tr>
                    <td>
                      <span>MotherTongue</span> :&nbsp;
                      {this.props.userDetails.MotherTounge}
                    </td>
                    <td>
                      <span>Minority</span> :&nbsp;
                      {this.props.userDetails.Occupation === 1 ? "Yes" : "No"}
                    </td>
                    <td colSpan="2" />
                  </tr>
                </tbody>
              </table>
            )}
            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 8
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Permanent Address
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>Permanent Address</span> :&nbsp;
                      {this.props.userDetails.Address}
                    </td>
                    <td width="28%">
                      <span>Area</span> :&nbsp;
                      {this.props.userDetails.Area}
                    </td>
                    <td width="20%">
                      <span>Country</span> :&nbsp;
                      {this.props.userDetails.CountryName}
                    </td>
                    <td>
                      <span>State</span> :&nbsp;
                      {this.props.userDetails.StateName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>City</span> :&nbsp;
                      {this.props.userDetails.CityName}
                    </td>
                    <td>
                      <span>Pin Code</span> :&nbsp;
                      {this.props.userDetails.PinCode}
                    </td>
                    <td colSpan="2">
                      <span>Phone</span> :&nbsp;
                      {this.props.userDetails.Phone}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 9
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Correspondence Address
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33%">
                      <span>Correspondence Address</span> :&nbsp;
                      {this.props.userDetails.CorrespondenceAddress}
                    </td>
                    <td width="28%">
                      <span>Area</span> :&nbsp;
                      {this.props.userDetails.CorrespondenceArea}
                    </td>
                    <td width="20%">
                      <span>Country</span> :&nbsp;
                      {this.props.userDetails.CorrespondCountryName}
                    </td>
                    <td>
                      <span>State</span> :&nbsp;
                      {this.props.userDetails.CorrespondStateName}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>City</span> :&nbsp;
                      {this.props.userDetails.CorrespondCityName}
                    </td>
                    <td>
                      <span>Pin Code</span> :&nbsp;
                      {this.props.userDetails.CorrespondencePinCode}
                    </td>
                    <td colSpan="2">
                      <span>Phone</span> :&nbsp;
                      {this.props.userDetails.CorrespondencePhone}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 10
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Family Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(this.props.userDetails.FatherName !== "" ||
                    this.props.userDetails.FatherMobNo !== "" ||
                    this.props.userDetails.FatherEmail !== "" ||
                    this.props.userDetails.FatherOccupation !== "") && (
                    <tr>
                      <td width="33%">
                        <span>Father Name</span> :&nbsp;
                        {this.props.userDetails.FatherName}
                      </td>
                      <td width="28%">
                        <span>Father Mobile</span> :&nbsp;
                        {this.props.userDetails.FatherMobNo}
                      </td>
                      <td width="20%">
                        <span>Father Email</span> :&nbsp;
                        {this.props.userDetails.FatherEmail}
                      </td>
                      <td>
                        <span>Father Occupation</span> :&nbsp;
                        {this.props.userDetails.FatherOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.MotherName !== "" ||
                    this.props.userDetails.MotherMobNo !== "" ||
                    this.props.userDetails.MotherEmail !== "" ||
                    this.props.userDetails.MotherOccupation !== "") && (
                    <tr>
                      <td>
                        <span>Mother Name</span> :&nbsp;
                        {this.props.userDetails.MotherName}
                      </td>
                      <td>
                        <span>Mother Mobile</span> :&nbsp;
                        {this.props.userDetails.MotherMobNo}
                      </td>
                      <td>
                        <span>Mother Email</span> :&nbsp;
                        {this.props.userDetails.MotherEmail}
                      </td>
                      <td>
                        <span>Mother Occupation</span> :&nbsp;
                        {this.props.userDetails.MotherOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.GuardianName !== "" ||
                    this.props.userDetails.GuardianMobNo !== "" ||
                    this.props.userDetails.GuardianEmail !== "" ||
                    this.props.userDetails.GuardianOccupation !== "" ||
                    this.props.userDetails.GuardianRelation !== "") && (
                    <tr>
                      <td>
                        <span>Guardian Name</span> :&nbsp;
                        {this.props.userDetails.GuardianName}
                      </td>
                      <td>
                        <span>Guardian Mobile</span> :&nbsp;
                        {this.props.userDetails.GuardianMobNo}
                      </td>
                      <td>
                        <span>Guardian Email</span> :&nbsp;
                        {this.props.userDetails.GuardianEmail}
                      </td>
                      <td>
                        <span>Guardian Occupation</span> :&nbsp;
                        {this.props.userDetails.GuardianOccupation}
                      </td>
                    </tr>
                  )}
                  {(this.props.userDetails.GuardianName !== "" ||
                    this.props.userDetails.GuardianMobNo !== "" ||
                    this.props.userDetails.GuardianEmail !== "" ||
                    this.props.userDetails.GuardianOccupation !== "" ||
                    this.props.userDetails.GuardianRelation !== "") && (
                    <tr>
                      <td colSpan="4">
                        <span>Guardian Relation</span> :&nbsp;
                        {this.props.userDetails.GuardianRelation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.SpouseName !== "" ||
                    this.props.userDetails.SpouseMobNo !== "" ||
                    this.props.userDetails.SpouseEmail !== "" ||
                    this.props.userDetails.SpouseOccupation !== "" ||
                    this.props.userDetails.SpouseRelation !== "") && (
                    <tr>
                      <td>
                        <span>Spouse Name</span> :&nbsp;
                        {this.props.userDetails.SpouseName}
                      </td>
                      <td>
                        <span>Spouse Mobile</span> :&nbsp;
                        {this.props.userDetails.SpouseMobNo}
                      </td>
                      <td>
                        <span>Spouse Email</span> :&nbsp;
                        {this.props.userDetails.SpouseEmail}
                      </td>
                      <td>
                        <span>Spouse Occupation</span> :&nbsp;
                        {this.props.userDetails.SpouseOccupation}
                      </td>
                    </tr>
                  )}

                  {(this.props.userDetails.SpouseName !== "" ||
                    this.props.userDetails.SpouseMobNo !== "" ||
                    this.props.userDetails.SpouseEmail !== "" ||
                    this.props.userDetails.SpouseOccupation !== "" ||
                    this.props.userDetails.SpouseRelation !== "") && (
                    <tr>
                      <td colSpan="4">
                        <span>Spouse Relation</span> :&nbsp;
                        {this.props.userDetails.SpouseRelation}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 11
            ).length > 0 && (
              <div>
                {this.state.allAchievementsData.length > 0 && (
                  <table className="table table-bordered dashboard-table mb-1 ">
                    <thead>
                      <tr>
                        <th colSpan="2" className="table-light">
                          Achievements Area &amp; Field
                        </th>
                        <th colSpan="2" className="table-light">
                          Achievements Specialization
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allAchievementsData.map(
                        (achievement, index) => {
                          return (
                            achievement.AchievementName !== undefined &&
                              achievement.AchievementName !== "",
                            achievement.Specialization !== undefined &&
                            achievement.Specialization !== "" ? (
                              <tr key={index}>
                                <td colSpan="2">
                                  {achievement.AchievementName}
                                </td>
                                <td colSpan="2">
                                  {achievement.Specialization}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        }
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 12
            ).length > 0 && (
              <div>
                {this.state.allLanguagesData.length > 0 && (
                  <table className="table table-bordered dashboard-table mb-1 ">
                    <thead>
                      <tr>
                        <th className="table-light" width="33%">
                          Languages Known
                        </th>

                        <th className="table-light" width="28%">
                          Speaking
                        </th>
                        <th className="table-light" width="20%">
                          Reading
                        </th>
                        <th className="table-light">Writing</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allLanguagesData.map((languages, index) => {
                        return (
                          languages.LanguageName !== undefined &&
                            languages.LanguageName !== "",
                          languages.Speaking !== undefined &&
                            languages.Speaking !== "",
                          languages.Reading !== undefined &&
                            languages.Reading !== "",
                          languages.Writing !== undefined &&
                          languages.Writing !== "" ? (
                            <tr key={index}>
                              <td>{languages.LanguageName}</td>
                              <td>
                                {(parseInt(languages.Speaking, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Speaking, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Speaking, 10) === 1 &&
                                    "Fair")}
                              </td>
                              <td>
                                {(parseInt(languages.Reading, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Reading, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Reading, 10) === 1 &&
                                    "Fair")}
                              </td>
                              <td>
                                {(parseInt(languages.Writing, 10) === 3 &&
                                  "Excellent") ||
                                  (parseInt(languages.Writing, 10) === 2 &&
                                    "Good") ||
                                  (parseInt(languages.Writing, 10) === 1 &&
                                    "Fair")}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 13
            ).length > 0 && (
              <table className="table table-bordered dashboard-table mb-1 ">
                <thead>
                  <tr>
                    <th colSpan="4" className="table-light">
                      Foreign Student Visa Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4">
                      <span>Is Foreign Student</span> :&nbsp;
                      {this.props.userDetails.IsForeignStudent === 1
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  {this.props.userDetails.IsForeignStudent === 1 && (
                    <tr>
                      <td>
                        <span>Passport No</span> :&nbsp;
                        {this.props.userDetails.PassportNo}
                      </td>
                      <td>
                        <span>Visa Details</span> :&nbsp;
                        {this.props.userDetails.VisaDetails}
                      </td>
                      <td>
                        <span>Issue Date</span> :&nbsp;
                        {moment(this.props.userDetails.IssueDate).isValid()
                          ? moment(this.props.userDetails.IssueDate).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </td>
                      <td>
                        <span>Expiry Date</span> :&nbsp;
                        {moment(this.props.userDetails.ExpiryDate).isValid()
                          ? moment(this.props.userDetails.ExpiryDate).format(
                              "DD-MM-YYYY"
                            )
                          : ""}
                      </td>
                    </tr>
                  )}
                  {this.props.userDetails.IsForeignStudent === 1 && (
                    <tr>
                      <td>
                        <span>Name Of Country</span> :&nbsp;
                        {this.props.userDetails.NameOfCountry}
                      </td>
                      <td>
                        <span>Type of VISA</span> :&nbsp;
                        {this.props.userDetails.TypeOfVISA}
                      </td>
                      <td colSpan="2" />
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* <header className="print-header displayPrintOnly">
            {this.props.admissionFormList.length > 0 && (
              <div>
                {this.props.admissionFormList
                  .filter(data => {
                    return data.ID === parseInt(this.props.FormId, 10);
                  })
                  .map((item, index) => {
                    return (
                      <div className="documentData" key={index}>
                        <h2 className="text-center"> {item.FormGroupName}</h2>
                        <ul className="documentDataList">
                          <li>
                            <strong>Application No</strong> :{" "}
                            {this.state.AdmissionNo || ""}
                          </li>
                          <li>
                            <strong>Form Fees</strong> :{" "}
                            {`₹${this.state.FormFees || ""}`}
                          </li>
                        </ul>
                        <p className="formDate">
                          <strong>Application Date</strong> :{" "}
                          {this.state.AdmissionDate}
                        </p>
                      </div>
                    );
                  })}
              </div>
            )}
          </header> */}
        <AcademicInfoPrint FormId={this.props.FormId} />

        { this.state.IsFormFeesPaid && this.state.IsVerifyUser ? 
        <NavLink
            className="btn btn-success mr-0 btn-lg theme-btn"
            to={`/Account/StudentAccount/AdmissionForm/4/${this.props.FormId}`}
          >
            Next <i className="fa fa-angle-right" aria-hidden="true" />
          </NavLink>
        
        :  !this.state.isNextBtn && this.state.IsVerifyUser ? (
          // <NavLink
          //   className="btn btn-success mr-0 btn-lg theme-btn"
          //   to={`/Account/StudentAccount/AdmissionForm/4/${this.props.FormId}`}
          // >
          //   Next <i className="fa fa-angle-right" aria-hidden="true" />
          // </NavLink>

          <button
            className="btn btn-success mr-0 btn-lg theme-btn"
            type="button"
            onClick={this.onOpenModal}
          >
            <i className="fa fa-check" aria-hidden="true" />
            Re-Verify
          </button>
        ) : (
          <button
            className="btn btn-success mr-0 btn-lg theme-btn"
            type="button"
            onClick={this.onOpenModal}
          >
            <i className="fa fa-check" aria-hidden="true" />
            Verify
          </button>
        )}

        {/* {this.state.isNextBtn && (
          <NavLink
          className="btn btn-success mr-0 btn-lg theme-btn"
          to={`/Account/StudentAccount/AdmissionForm/4/${this.props.FormId}`}
        >
          Next <i className="fa fa-angle-right" aria-hidden="true" />
        </NavLink>
        )} */}
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  userDetails,
  update,
  achievementByStudent,
  languageKnownByStudent,
  admissionFormList,
  admissionProgram,
  admissionVerifyDetails,
  admissionFormConfiguration,
  admissionTotalFormFees,
  admissionStudentStatusDetails,
  academicQuotaList,
  admissionOtherDetails,
}) {
  return {
    auth,
    userDetails,
    achievementByStudent,
    languageKnownByStudent,
    admissionFormList,
    admissionProgram,
    update,
    admissionVerifyDetails,
    admissionFormConfiguration,
    admissionTotalFormFees,
    admissionStudentStatusDetails,
    academicQuotaList,
    admissionOtherDetails
  };
}
export default connect(mapStateToProps, {
  getUserDetailsByUserId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  clearUpdate,
  getFormVerifyDetailsByStudentId,
  admissionInsertVerifyDetails,
  getAllAdmissionFormConfigurationByFormId,
  getAdmissionTotalFormFeesByStudentId,
  payOnlinePayment,
  getStudentStatusDetailsByUserId,
  getAcademicQuotaDetailsByStudentId,
  getOtherDetailsByStudentId,
})(AdmissionVerifyPrint);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AdmissionVerifyPrint.js